import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsTHandlingLogAssignmentOrderExistingPlanEvent } from "../../../common/types/order-details-handling-log-entry-event";

const getRouteLabel = (
  planEntryUuid: OrderDetailsTHandlingLogAssignmentOrderExistingPlanEvent["planEntryUuid"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .assignmentOrderExistingPlan.routeLabel;

  return translations.replace(
    "#{planEntryUuid}",
    planEntryUuid.toString() ?? "-----",
  );
};

const getTaxiCorporationName = (
  taxiCorporationName: OrderDetailsTHandlingLogAssignmentOrderExistingPlanEvent["taxiCorporationName"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .assignmentOrderExistingPlan.taxiCorporationNameLabel;

  return translations.replace(
    "#{taxiCorporationName}",
    taxiCorporationName ?? "-----",
  );
};

const getDriverName = (
  driverName: OrderDetailsTHandlingLogAssignmentOrderExistingPlanEvent["driverName"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .assignmentOrderExistingPlan.driverNameLabel;

  return translations.replace("#{driverName}", driverName ?? "-----");
};

const orderDetailsHistoryEntryAssignmentOrderExistingPlanContentHelper = {
  getRouteLabel,
  getTaxiCorporationName,
  getDriverName,
};

export default orderDetailsHistoryEntryAssignmentOrderExistingPlanContentHelper;
